<div id="_ngView-CENTER_" class="my-2 px-2 text-1.25 w-1/2 flex flex-col border">
  <div>Full Communication Established</div>

  @for (informationRace of informationRacesComm; track informationRace._id) {
    <div class="w-full flex flex-col">
      <hr />
      Star System #{{ starSystemHash[informationRace.aboutRace.starSystemId].number }} - {{ informationRace.aboutRace.name }} ({{ informationRace.aboutRace.techLevel > 0 ? "High Tech" : "Low Tech" }})
      <table class="w-1/2">
        <tr>
          <th>
            <label># of Attempts:</label>
          </th>
          <td>
            {{ informationRace.communicationAttemptCount || 0 }}
          </td>
        </tr>
        <tr>
          <th>
            <label>Communication State:</label>
          </th>
          <td>
            {{ informationRace.communicationState }}
          </td>
        </tr>
      </table>
    </div>
  }
  <!--  -->
  @empty {
    <div>No races with Full Communication Established</div>
  }
</div>
